export function hhmmToIsoToday(hhmm?: string | null): string | undefined {
  if (!hhmm) return undefined
  const [h, m] = hhmm.split(':').map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return undefined
  const d = new Date()
  d.setHours(h ?? 0, m ?? 0, 0, 0)
  return d.toISOString()
}

export function hhmmToSeconds(hhmm?: string): number | undefined {
  if (!hhmm) return undefined
  const [h, m] = hhmm.split(':').map(Number)
  if (Number.isNaN(h) || Number.isNaN(m)) return undefined
  return h * 3600 + m * 60
}

export const intervalValue = (seconds: number) => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)

  const h = String(hours).padStart(2, "0")
  const m = String(minutes).padStart(2, "0")

  return `${h}:${m}`
}

// De ISO para "hh:mm"
export function isoToHhmm(iso?: string | null): string | undefined {
  if (!iso) return undefined
  const d = new Date(iso)
  const h = String(d.getHours()).padStart(2, "0")
  const m = String(d.getMinutes()).padStart(2, "0")
  return `${h}:${m}`
}

// De segundos para "hh:mm"
export function secondsToHhmm(seconds?: number | null): string | undefined {
  if (seconds == null) return undefined
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0")
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0")
  return `${h}:${m}`
}

